/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Pre_Purchase_TitleInputs */



/**
* | output |
* | --- |
* | "Pre-purchase, delivery and charter surveys" |
*
* @param {Service_Pre_Purchase_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_pre_purchase_title = /** @type {((inputs?: Service_Pre_Purchase_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Pre_Purchase_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("买船前、交船及租船检验")
	return /** @type {LocalizedString} */ ("Pre-purchase, delivery and charter surveys")
});